import { localize, translationKey } from '../i18n';

// Preset values stay canonical in storage. Custom notes remain the user's words.
export const DIRECT_INPUT_REASON = translationKey('직접 입력');
export const SKIP_REASON_OPTIONS = [
    translationKey('깜빡했어요'), translationKey('약이 없어요'), translationKey('몸이 불편해요'),
    translationKey('부작용'), translationKey('의료진 안내'), DIRECT_INPUT_REASON,
];
const storedPresets = new Set([
    ...SKIP_REASON_OPTIONS.filter(reason => reason !== DIRECT_INPUT_REASON),
    translationKey('외출 중'), translationKey('약 미소지'), translationKey('의사 지시'), translationKey('컨디션 난조'),
]);
export function displaySkipReason(reason) {
    return typeof reason === 'string' && storedPresets.has(reason) ? localize(reason) : reason;
}
